import "./assets.scss";
import {useEffect, useState} from "react";
import CustomList from "../../../components/custom-list/custom-list";
import {useAppDispatch, useAppSelector} from "../../../features/helpers";
import {addAssets, fetchAssets, fetchNetowrks, getAssetsList, getModalAssetsStatus, setModalAssetStatus} from "../../../store/AssetsSlice";
import { Asset } from "../../../models/Assets";
import { ASSET_PRESETS, findExistingAsset } from "../../../utils/asset-presets";

const AssetReset : Asset = {
    id:0,
    name: '',
    symbol: '',
    type: ''
}

const AdminAssets = () => {

    const dispatch = useAppDispatch();

    const listAssets = useAppSelector(getAssetsList);
    const modalStatus = useAppSelector(getModalAssetsStatus);

    const networks =  useAppSelector((state) => state.assets.networks);

    const[addPayload, setAddPayload] = useState<Asset>(AssetReset);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement| HTMLSelectElement>) => {
        const { name, value } = e.target;

        setAddPayload(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const toggle = () => {
        dispatch(setModalAssetStatus(!modalStatus));
    }

    const isValid = () =>
        !!addPayload.name.trim() && !!addPayload.symbol.trim() &&!!addPayload.type.trim();

    const addAsset = () => {
    if (!isValid()) return;

    let finalPayload = addPayload;

    if (presetKey === "OUTRO") {
        const duplicate = findExistingAsset(addPayload, listAssets);
        if (duplicate) {
            finalPayload = { id: 0, ...duplicate };
        }
    }

    dispatch(addAssets(finalPayload))
}

    useEffect(() => {
        dispatch(fetchAssets())
    }, [networks])

const [presetKey, setPresetKey] = useState("");

const handlePresetChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const key = e.target.value;
    setPresetKey(key);

    if (key === "OUTRO" || key === "") {
        setAddPayload(AssetReset); // libera edicao manual
    } else {
        const preset = ASSET_PRESETS[key];
        setAddPayload({ id: 0, ...preset }); // preenche automatico
    }
};

const isLocked = presetKey !== "" && presetKey !== "OUTRO";

    return (
        <div className="assets-wrapper">
            <div className="actions-title">

                <h2 className="page-title">
                    Assets Cadastrados
                    <small>lista de assets cadastrados</small>
                </h2>
                <div className="buttons">
                    <div className="btn ghost" onClick={toggle}>Adicionar</div>
                </div>
            </div>

            {listAssets && Array.isArray(listAssets) && listAssets.length > 0 && (
                <div className="assets-custom-list">
                    <CustomList data={listAssets} options={true}/>
                </div>
            )}

            <div className={`modal ${!modalStatus ? 'hide' : ''}`}>
                <div className="shadow"></div>
                <div className="modal-body">
                    <h1 className="page-title">
                        Adicionar Asset
                        <small>adicionar um asset que pode ser transacionado na sua empresa</small>
                    </h1>

                    <div className="form-group">
                        <div className="label">Asset:</div>
                        <select value={presetKey} onChange={handlePresetChange}>
                            <option value="">Selecione</option>
                            {Object.keys(ASSET_PRESETS).map((key) => (
                                <option key={key} value={key}>{key}</option>
                            ))}
                            <option value="OUTRO">Outro</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <div className="label">Nome:</div>
                        <input
                            placeholder="Asset name"
                            name="name"
                            value={addPayload.name}
                            disabled={isLocked}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <div className="label">Symbol:</div>
                        <input
                            placeholder="Symbol"
                            name="symbol"
                            value={addPayload.symbol}
                            disabled={isLocked}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <div className="label">Tipo:</div>
                        <select name="type" onChange={handleChange} value={addPayload.type || ''} disabled={isLocked}>
                            <option value="">Selecione</option>
                            <option value="FIAT">FIAT</option>
                            <option value="CRYPTO">CRYPTO</option>
                        </select>
                    </div>

                    <div className="actions flex sb">
                        <button className="btn purple" onClick={toggle}>Cancel</button>
                        <button className="btn purple" disabled={!isValid()}  onClick={addAsset}>Adicionar</button>
                        

                    </div>
                </div>
            </div>

        </div>
    )
}

export default AdminAssets;